<template>
  <div class="productmain">
    <div class="main">
      <div class="bgc"></div>
      <div class="merchants">
        <div class="con">
          <p class="text-title">欧享贷</p>
          <p>
            对象：通过白名单风控筛选的OPPO经销商（门店）、品牌商、代理商、广告物流商客户。
          </p>
          <p>额度：单户贷款金额最高不超过800万元，授信额度有效期内循环可用。</p>
          <p>
            期限：最长期限为2年；随借随还；分期（月）还本付息/到期还本付息。
          </p>
          <p>
            利息：年利率7%起，按日计息，最高不超管监管规定上限（含违约金、罚息）。
          </p>
          <p>征信：接入征信</p>
        </div>
      </div>
      <div class="merchants">
        <div class="con">
          <p class="text-title">欢太花钱贷（含“欢太分期贷”）</p>
          <p>
            对象：通过白名单风控筛选的OPPO手机客户。
          </p>
          <p>额度：不超过人民币20万元，授信额度有效期内循环可用。</p>
          <p>
            期限：最长为3年；随借随还；分期（月）还本付息。
          </p>
          <p>
            利息：年利率10%起，按日计息，最高不超过监管规定上限（含违约金、罚息）。
          </p>
          <p>征信：接入征信</p>
        </div>
      </div>
      <div class="merchants">
        <div class="con">
          <p class="text-title">维易快贷</p>
          <p>
            对象：通过白名单风控筛选的vivo经销商（门店）、品牌商、代理商、广告物流商客户。
          </p>
          <p>额度：单户贷款金额最高不超过800万元，授信额度有效期内循环可用。</p>
          <p>
            期限：最长期限为2年；随借随还；分期（月）还本付息/到期还本付息。
          </p>
          <p>
            利息：年利率7%起，按日计息，最高不超管监管规定上限（含违约金、罚息）。
          </p>
          <p>征信：接入征信</p>
        </div>
      </div>
      <div class="merchants">
        <div class="con">
          <p class="text-title">维易贷（含 “维易分期贷”）</p>
          <p>
            对象：通过白名单风控筛选的vivo手机客户。
          </p>
          <p>额度：不超过人民币20万元，授信额度有效期内循环可用。</p>
          <p>期限：最长为3年；随借随还；分期（月）还本付息。</p>
          <p>
            利息：年利率10%起，按日计息，最高不超过监管规定上限（含违约金、罚息）。
          </p>
          <p>征信：接入征信</p>
        </div>
      </div>
      <div class="merchants">
        <div class="con">
          <p class="text-title">贷款流程</p>
          <div class="process">
            <div class="one">
              <div class="text">
                <span>用户申请</span>
              </div>
              <div class="line">
                <img src="../../assets/箭头.png" alt="箭头" />
              </div>
            </div>
            <div class="one">
              <div class="text">
                <span>授信审核</span>
              </div>
              <div class="line">
                <img src="../../assets/箭头.png" alt="箭头" />
              </div>
            </div>
            <div class="one">
              <div class="text">
                <span>提款申请</span>
              </div>
              <div class="line">
                <img src="../../assets/箭头.png" alt="箭头" />
              </div>
            </div>
            <div class="one">
              <div class="text">
                <span>贷款发放</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
};
</script>

<style lang="scss" scoped>
.productmain {
  width: 100%;
  .main {
    width: 100%;
    background-color: #f2f2f2;
    .bgc {
      width: 100%;
      height: 550px;
      background: url("../../assets/产品介绍页.jpg") center center no-repeat;
      background-size: 100% auto;
    }
    .merchants {
      width: 100%;
      color: #663333;
      text-align: left;
      .con {
        width: 100%;
        border: 1px solid #ccc;
        padding-left: 100px;
        padding-bottom: 50px;
        p {
          font-size: 18px;
          margin: 10px 0;
        }
        .text-title {
          font-size: 30px;
          padding-top: 30px;
          padding-bottom: 50px;
        }
        .process {
          display: flex;
          .one {
            display: flex;
            margin-right: 2px;
            .text {
              width: 150px;
              border-radius: 10px;
              padding: 20px;
              background-color: #b6a383;
              text-align: center;
              span {
                color: #fff;
                font-size: 30px;
              }
            }
            .line {
              height: 80px;
              line-height: 80px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Product/index.vue